export default __webpack_public_path__ + "static/media/noexpl_05_DE.84e9db95.png";